import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { RouteOffIcon, Sparkles } from "lucide-react";

type ItineraryButtonProps = {
  companiesCount: number;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
};

export function ItineraryButton({
  companiesCount,
  isActive,
  onClick,
  disabled = false,
}: ItineraryButtonProps) {
  const { t } = useTranslation();

  const isDisabled = disabled || companiesCount < 2;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <span>
          <Button variant="outline" disabled={isDisabled} onClick={onClick}>
            {isActive ? (
              <>
                <RouteOffIcon className="mr-2 w-4 h-4" />
                {t("listing.page.content.map.hideItinerary")}
              </>
            ) : (
              <>
                <Sparkles className="mr-2 w-4 h-4" />
                {t("listing.page.content.map.showItinerary")}
              </>
            )}
          </Button>
        </span>
      </TooltipTrigger>
      {companiesCount < 2 && (
        <TooltipContent>
          <p>{t("listing.page.content.map.itineraryTooltip")}</p>
        </TooltipContent>
      )}
    </Tooltip>
  );
}
